import { Action } from "redux";
import { call, delay, put, takeLeading } from "redux-saga/effects";

import { createHideLoadingIndicatorAction, createOpenFormModalAction, createShowLoadingIndicatorAction } from "@multiweb/reactCore/bridge";
import { IAttrValue } from "@multiweb/types/contracts";
import { IOpenFormModalParams, IOWObject } from "@multiweb/types/multiweb";
import { IOpenFormIconEditAction } from "UI/UI.React/components/IconEdit/types";

export const iconEditConnectorSaga = function* iconEditConnectorSaga(id: string, editWindow: string, assocName: string, getAssocNameObject: () => Promise<IAttrValue>, setAssocNameObject: (result: readonly IAttrValue[] | undefined) => void, isEnabled: () => boolean) {
    yield takeLeading((action: Action) => action instanceof IOpenFormIconEditAction && action.payload.id === id, onOpenFormModalSaga, editWindow, assocName, getAssocNameObject, setAssocNameObject, isEnabled);
};

export const onOpenFormModalSaga = function* onOpenFormModalSaga(editWindow: string, assocName: string, getAssocNameObject: () => Promise<IAttrValue>, setAssocNameObject: (result: readonly IAttrValue[] | undefined) => void, isEnabled: () => boolean) {
    const throttleDelay = 2000;
    yield put(createShowLoadingIndicatorAction());
    if (assocName && editWindow) {
        /* V případě neaktivnosti se otevírá jiný formulář */
        if (isEnabled()) {
            const params: IOpenFormModalParams = {
                formName: editWindow,
                attributeNames: ["ID"],
                onClose: (result: readonly IAttrValue[] | undefined) => {
                    setAssocNameObject(result);
                },
                inLOVMode: true,
                enableLOVSelect: true,
                viewMode: true,
            };
            yield put(createOpenFormModalAction(params));
        } else {
            const assocNameObject: IOWObject = yield call(getAssocNameObject);
            if (assocNameObject && !!assocNameObject.id) {
                const params: IOpenFormModalParams = {
                    formName: editWindow,
                    attributeNames: ["ID"],
                    condition: "(ID = " + assocNameObject.id + ")",
                };
                yield put(createOpenFormModalAction(params));
            }
        }
    }
    yield put(createHideLoadingIndicatorAction());
    yield delay(throttleDelay);
};
